// Module
var code = "<main class=\"app-container bookkeeperContainer\"> <div ng-show=\"includes('app.bookkeeper')\" ng-cloak> <div ng-include src=\" 'app/components/core/blocks/sidebar-bookkeeper.html' \" include-replace></div> </div> <div style=\"padding-left:316px\" ui-view></div> </main> ";
// Exports
module.exports = code;